import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectCurrentFanspeed } from './fanspeed-store/fanspeed.selector';
import { FanspeedComponent } from './fanspeed.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-fanspeed',
  templateUrl: './fanspeed.container.html',
  imports: [FanspeedComponent],
})
export class FanspeedContainerComponent {
  private readonly store = inject(Store);

  public readonly currentFanspeed = this.store.selectSignal(selectCurrentFanspeed);
}
